// extracted by mini-css-extract-plugin
export default {"spinnerPosition":"UK2Eb","signList":"G3n40","signIn":"yTAoP","registrationBtn":"cN0Yr","signing":"izedT"};